/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from 'react';
import {Progress, Spin} from 'antd';
import {Button} from 'icsoc-antd-ex';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import IconFont from 'Components/common/iconFont';
import tCommonActions from 'Actions/common';

import './index.less';

class TaskProgress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      visible: false,
    };
    this.timer = null;
  }

  refresh = () => {
    this.toggle(true);
  };

  toggle = status => {
    let nextStatus = status;
    const {visible} = this.state;

    if (typeof status !== 'boolean') {
      nextStatus = !visible;
    }

    this.setState(
      {
        visible: nextStatus,
      },
      () => {
        this.countDown();

        if (nextStatus) {
          this.getDataSource();
        }
      },
    );
  };

  getDataSource = () => {
    const {commonActions} = this.props;

    this.setState({loading: true});

    commonActions.getTaskProgress().finally(() => {
      this.setState({loading: false});
    });
  };

  countDown() {
    const {visible} = this.state;
    if (this.timer) {
      clearTimeout(this.timer);
    }

    if (visible) {
      this.timer = setTimeout(this.toggle, 30000);
    }
  }

  render() {
    const {
      common: {taskProgress: {all = 0, finish = 0} = {}} = {},
    } = this.props;
    const {visible, loading} = this.state;

    return (
      <div className="task-progress">
        {/* <span className="task-progress-btn" onClick={() => this.toggle(true)}>
          <IconFont type="icon-robotprogress" style={{marginRight: '8px'}} />
          项目进度
        </span> */}
        <Button onClick={() => this.toggle(true)}>
          <IconFont type="icon-robotprogress" />项目进度
        </Button>

        <div className={`task-progress-content${visible ? ' is-show' : ''}`}>
          <IconFont
            type="icon-robotchevron-right"
            className="close-btn"
            onClick={() => this.toggle(false)}
          />
          <Spin spinning={loading}>
            <h2>
              <a style={{float: 'right'}} onClick={this.refresh}>
                刷新
              </a>
              项目进度
            </h2>
            <Progress
              percent={Number(((finish / (all || 1)) * 100).toFixed(2))}
              strokeWidth={14}
            />
            <p>
              整体呼叫进度：
              <span className="error-color">{finish}</span>
              /
              {all}
              （当前/总数）
            </p>
          </Spin>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    common: state.common,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(tCommonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TaskProgress);
